exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input.filter-checkbox{margin:10px 3px 10px 4px}.filters label{font-weight:400}", ""]);

// exports
